/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import * as THREE from "three";

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
html{scroll-behavior:smooth}
body{background:#0B0B0B;color:#fff;font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;overflow-x:hidden;-webkit-font-smoothing:antialiased}
::selection{background:rgba(108,59,255,.35);color:#fff}
::-webkit-scrollbar{width:3px}
::-webkit-scrollbar-track{background:#0B0B0B}
::-webkit-scrollbar-thumb{background:linear-gradient(180deg,#6C3BFF,#a78bfa);border-radius:99px}

.rv {opacity:0;transform:translateY(52px);transition:opacity .9s cubic-bezier(.16,1,.3,1),transform .9s cubic-bezier(.16,1,.3,1)}
.rvl{opacity:0;transform:translateX(-64px);transition:opacity .9s cubic-bezier(.16,1,.3,1),transform .9s cubic-bezier(.16,1,.3,1)}
.rvr{opacity:0;transform:translateX(64px);transition:opacity .9s cubic-bezier(.16,1,.3,1),transform .9s cubic-bezier(.16,1,.3,1)}
.rv.vis,.rvl.vis,.rvr.vis{opacity:1;transform:none}
.d1{transition-delay:.10s!important}.d2{transition-delay:.20s!important}
.d3{transition-delay:.30s!important}.d4{transition-delay:.40s!important}
.d5{transition-delay:.50s!important}.d6{transition-delay:.60s!important}

@keyframes shimmer{0%{background-position:-200% center}100%{background-position:200% center}}
@keyframes pulse-glow{0%,100%{box-shadow:0 0 22px rgba(108,59,255,.28),0 0 44px rgba(108,59,255,.12)}50%{box-shadow:0 0 44px rgba(108,59,255,.65),0 0 88px rgba(108,59,255,.30)}}
@keyframes ring-glow{0%,100%{box-shadow:0 0 0 1px rgba(108,59,255,.28)}50%{box-shadow:0 0 0 3px rgba(108,59,255,.55),0 0 28px rgba(108,59,255,.22)}}
@keyframes dot-blink{0%,80%,100%{transform:scale(0);opacity:0}40%{transform:scale(1);opacity:1}}
@keyframes slide-in{from{transform:translateY(14px);opacity:0}to{transform:translateY(0);opacity:1}}
@keyframes scroll-drop{0%,100%{transform:translateY(0);opacity:.6}50%{transform:translateY(10px);opacity:.2}}

.g-text{
  background:linear-gradient(130deg,#fff 0%,#c4b5fd 30%,#6C3BFF 60%,#c4b5fd 100%);
  background-size:300% auto;-webkit-background-clip:text;-webkit-text-fill-color:transparent;
  background-clip:text;animation:shimmer 5s linear infinite
}
.w-wrap{display:inline-block;overflow:hidden;vertical-align:bottom}
.w-inner{display:inline-block;opacity:0;transform:translateY(115%);transition:transform .75s cubic-bezier(.16,1,.3,1),opacity .75s ease}
.w-inner.vis{transform:translateY(0);opacity:1}

.nav{position:fixed;top:0;left:0;right:0;z-index:1000;padding:22px 0;transition:all .4s cubic-bezier(.16,1,.3,1)}
.nav.on{background:rgba(11,11,11,.88);backdrop-filter:blur(28px) saturate(200%);-webkit-backdrop-filter:blur(28px) saturate(200%);padding:13px 0;border-bottom:1px solid rgba(255,255,255,.05)}

.btn-p{display:inline-flex;align-items:center;gap:8px;background:#6C3BFF;color:#fff;border:none;padding:15px 34px;border-radius:50px;font-size:15px;font-weight:600;letter-spacing:.01em;cursor:pointer;position:relative;overflow:hidden;transition:transform .3s cubic-bezier(.16,1,.3,1),box-shadow .3s ease;animation:pulse-glow 3s ease-in-out infinite;text-decoration:none;font-family:inherit}
.btn-p:hover{transform:translateY(-4px) scale(1.04);box-shadow:0 22px 55px rgba(108,59,255,.52)}
.btn-p::after{content:'';position:absolute;inset:0;background:linear-gradient(135deg,rgba(255,255,255,.16),transparent);pointer-events:none}
.btn-o{display:inline-flex;align-items:center;gap:8px;background:transparent;color:#fff;border:1px solid rgba(255,255,255,.24);padding:15px 34px;border-radius:50px;font-size:15px;font-weight:500;letter-spacing:.01em;cursor:pointer;font-family:inherit;transition:all .3s cubic-bezier(.16,1,.3,1);animation:ring-glow 3.5s ease-in-out infinite;text-decoration:none}
.btn-o:hover{border-color:#6C3BFF;background:rgba(108,59,255,.12);transform:translateY(-4px) scale(1.04)}

.s-tag{display:inline-flex;align-items:center;gap:7px;background:rgba(108,59,255,.1);border:1px solid rgba(108,59,255,.28);color:#a78bfa;font-size:11px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;padding:6px 15px;border-radius:50px}

.svc-card{border:1px solid rgba(255,255,255,.07);border-radius:24px;padding:40px;background:rgba(255,255,255,.02);transition:all .4s cubic-bezier(.16,1,.3,1);cursor:default;position:relative;overflow:hidden}
.svc-card::before{content:'';position:absolute;inset:0;background:linear-gradient(135deg,rgba(108,59,255,.09),transparent);opacity:0;transition:opacity .4s;border-radius:inherit}
.svc-card:hover{transform:translateY(-12px);border-color:rgba(108,59,255,.65);box-shadow:0 32px 80px rgba(108,59,255,.22)}
.svc-card:hover::before{opacity:1}

.p-card{border-radius:18px;overflow:hidden;position:relative;cursor:pointer;transition:transform .45s cubic-bezier(.16,1,.3,1),box-shadow .45s ease}
.p-card:hover{transform:scale(1.03);box-shadow:0 26px 72px rgba(108,59,255,.30)}
.p-overlay{position:absolute;inset:0;background:linear-gradient(160deg,rgba(108,59,255,.22),rgba(11,11,11,.92));display:flex;align-items:center;justify-content:center;flex-direction:column;gap:10px;opacity:0;transition:opacity .4s ease}
.p-card:hover .p-overlay{opacity:1}

.w-row{display:flex;align-items:center;gap:16px;padding:17px 22px;border:1px solid rgba(255,255,255,.07);border-radius:14px;background:rgba(255,255,255,.02);transition:all .3s cubic-bezier(.16,1,.3,1);cursor:default}
.w-row:hover{border-color:rgba(108,59,255,.48);background:rgba(108,59,255,.05);transform:translateX(12px)}

.t-card{flex-shrink:0;min-width:340px;border:1px solid rgba(255,255,255,.07);border-radius:20px;padding:30px;background:rgba(255,255,255,.025);transition:transform .3s ease,border-color .3s ease,box-shadow .3s ease}
.t-card:hover{transform:translateY(-8px) scale(1.015);border-color:rgba(108,59,255,.48);box-shadow:0 22px 55px rgba(108,59,255,.16)}

.c-msg{animation:slide-in .45s cubic-bezier(.16,1,.3,1) forwards;opacity:0}
.h-scroll{display:flex;gap:20px;overflow-x:auto;cursor:grab;user-select:none;padding:16px 0;scrollbar-width:thin;scrollbar-color:#6C3BFF transparent}
.h-scroll:active{cursor:grabbing}
.h-scroll::-webkit-scrollbar{height:2px}
.h-scroll::-webkit-scrollbar-thumb{background:#6C3BFF;border-radius:99px}

.port-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:14px}
.svc-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px}
.trust-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:32px}
.why-grid{display:grid;grid-template-columns:1fr 1fr;gap:80px;align-items:center}

@media(max-width:900px){
  .svc-grid{grid-template-columns:1fr!important}
  .why-grid{grid-template-columns:1fr!important;gap:52px!important}
  .trust-grid{grid-template-columns:1fr!important}
  .port-grid{grid-template-columns:1fr 1fr!important}
  .port-span2{grid-column:span 2!important}
  .nav-links{display:none!important}
  .hero-pad{padding-top:120px!important}
}
@media(max-width:560px){
  .port-grid{grid-template-columns:1fr!important}
  .port-span2{grid-column:span 1!important}
  .cta-btns{flex-direction:column!important;align-items:stretch!important}
  .cta-btns button{width:100%!important;justify-content:center!important}
}
`;

// ── Hooks ──────────────────────────────────────────────────────────────────
function useReveal(ref) {
  useEffect(() => {
    if (!ref?.current) return;
    const els = ref.current.querySelectorAll(".rv,.rvl,.rvr");
    if (!els.length) return;
    const io = new IntersectionObserver(
      es => es.forEach(e => { if (e.isIntersecting) e.target.classList.add("vis"); }),
      { threshold: 0.1, rootMargin: "0px 0px -55px 0px" }
    );
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);
}

function useCounter(target, dur = 2200) {
  const [val, setVal] = useState(0);
  const el  = useRef(null);
  const hit = useRef(false);
  useEffect(() => {
    if (!el.current) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !hit.current) {
        hit.current = true;
        const t0 = performance.now();
        const step = now => {
          const p = Math.min((now - t0) / dur, 1);
          setVal(Math.round((1 - Math.pow(1 - p, 4)) * target));
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    }, { threshold: 0.6 });
    io.observe(el.current);
    return () => io.disconnect();
  }, [target, dur]);
  return [val, el];
}

// ── Navbar ─────────────────────────────────────────────────────────────────
function Navbar() {
  const [on, setOn]     = useState(false);
  const [hide, setHide] = useState(false);
  const lastY = useRef(0);
  useEffect(() => {
    const fn = () => {
      const y = window.scrollY;
      setOn(y > 48);
      setHide(y > lastY.current && y > 350);
      lastY.current = y;
    };
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);
  const go = id => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <nav className={`nav${on ? " on" : ""}`} style={{ transform: hide ? "translateY(-100%)" : "translateY(0)" }}>
      <div style={{ maxWidth:1200,margin:"0 auto",padding:"0 40px",display:"flex",alignItems:"center",justifyContent:"space-between" }}>
        <div onClick={() => window.scrollTo({ top:0, behavior:"smooth" })}
          style={{ fontSize:22,fontWeight:800,letterSpacing:"-.03em",cursor:"pointer" }}>
          IB<span style={{ color:"#6C3BFF" }}>VFX</span>
        </div>
        <div className="nav-links" style={{ display:"flex",gap:32 }}>
          {[["Work","work"],["Services","services"],["About","about"],["Contact","contact"]].map(([l,id]) => (
            <span key={id} onClick={() => go(id)}
              style={{ fontSize:14,fontWeight:500,color:"rgba(255,255,255,.62)",cursor:"pointer",transition:"color .2s",letterSpacing:".01em" }}
              onMouseEnter={e => e.target.style.color="#fff"}
              onMouseLeave={e => e.target.style.color="rgba(255,255,255,.62)"}>{l}</span>
          ))}
        </div>
        <button className="btn-p" style={{ padding:"11px 26px",fontSize:13 }} onClick={() => go("contact")}>Hire Us</button>
      </div>
    </nav>
  );
}

// ── Hero ───────────────────────────────────────────────────────────────────
function Hero() {
  const cvs   = useRef(null);
  const mouse = useRef({ x:0, y:0 });
  const wRefs = useRef([]);
  const WORDS = "We Don't Edit Videos. We Create Impact.".split(" ");

  useEffect(() => {
    const base = 500;
    WORDS.forEach((_, i) => setTimeout(() => wRefs.current[i]?.classList.add("vis"), base + i * 72));
    setTimeout(() => wRefs.current[WORDS.length]?.classList.add("vis"),   base + WORDS.length * 72 + 90);
    setTimeout(() => wRefs.current[WORDS.length+1]?.classList.add("vis"), base + WORDS.length * 72 + 220);
  }, []);

  useEffect(() => {
    const canvas = cvs.current;
    if (!canvas) return;
    const W = window.innerWidth, H = window.innerHeight;

    const renderer = new THREE.WebGLRenderer({ canvas, antialias:true, alpha:true });
    renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
    renderer.setSize(W, H);
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.35;

    const scene  = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(52, W/H, 0.1, 100);
    camera.position.z = 5.8;

    scene.add(new THREE.AmbientLight(0xffffff, 0.35));
    const pl1 = new THREE.PointLight(0x6C3BFF, 12, 28); pl1.position.set( 4, 4,  4); scene.add(pl1);
    const pl2 = new THREE.PointLight(0x3b82f6,  8, 22); pl2.position.set(-4,-3,  3); scene.add(pl2);
    const pl3 = new THREE.PointLight(0xec4899,  5, 18); pl3.position.set( 0, 5, -3); scene.add(pl3);
    const dir = new THREE.DirectionalLight(0xffffff, 0.9); dir.position.set(5,8,5); scene.add(dir);

    const grp = new THREE.Group(); scene.add(grp);
    const mkMat = (color, opts={}) => new THREE.MeshPhysicalMaterial({ color, metalness:.05, roughness:.04, clearcoat:1, clearcoatRoughness:.03, reflectivity:.95, ...opts });

    const core = new THREE.Mesh(new THREE.IcosahedronGeometry(1.28,1), mkMat(0x7c5cfc,{ transparent:true, opacity:.88 }));
    try { core.material.transmission = 0.82; } catch(e) {}
    grp.add(core);

    const wire = new THREE.Mesh(new THREE.IcosahedronGeometry(1.44,1),
      new THREE.MeshBasicMaterial({ color:0x6C3BFF, wireframe:true, transparent:true, opacity:.11 }));
    grp.add(wire);

    grp.add(new THREE.Mesh(new THREE.OctahedronGeometry(1.88,0),
      new THREE.MeshPhysicalMaterial({ color:0x8B5CF6, transparent:true, opacity:.1, side:THREE.BackSide, roughness:.25 })));

    const tetra = new THREE.Mesh(new THREE.TetrahedronGeometry(.68,0), mkMat(0xc4b5fd,{ transparent:true, opacity:.72 }));
    grp.add(tetra);

    const N=1200, pp=new Float32Array(N*3);
    for(let i=0;i<N;i++){
      const r=2.4+Math.random()*4.2, th=Math.random()*Math.PI*2, ph=Math.acos(2*Math.random()-1);
      pp[i*3]=r*Math.sin(ph)*Math.cos(th); pp[i*3+1]=r*Math.sin(ph)*Math.sin(th); pp[i*3+2]=r*Math.cos(ph);
    }
    const pGeo=new THREE.BufferGeometry();
    pGeo.setAttribute("position",new THREE.BufferAttribute(pp,3));
    const pts=new THREE.Points(pGeo,new THREE.PointsMaterial({ size:.024, color:0x8B5CF6, transparent:true, opacity:.62, sizeAttenuation:true }));
    scene.add(pts);

    const mkRing=(r,t,c,rx,ry)=>{ const m=new THREE.Mesh(new THREE.TorusGeometry(r,t,8,140),new THREE.MeshBasicMaterial({ color:c, transparent:true, opacity:.2 })); m.rotation.x=rx; m.rotation.y=ry; return m; };
    const rings=[mkRing(2.35,.011,0x6C3BFF,Math.PI/4,0),mkRing(3.00,.007,0x8B5CF6,-Math.PI/5,Math.PI/6),mkRing(3.65,.005,0xec4899,Math.PI/3,Math.PI/4)];
    rings.forEach(r=>scene.add(r));

    const onMouse = e => { mouse.current={ x:(e.clientX/W)*2-1, y:-(e.clientY/H)*2+1 }; };
    const onResize = () => { const nw=window.innerWidth,nh=window.innerHeight; camera.aspect=nw/nh; camera.updateProjectionMatrix(); renderer.setSize(nw,nh); };
    window.addEventListener("mousemove",onMouse);
    window.addEventListener("resize",onResize);

    const clk=new THREE.Clock(); const tgt={x:0,y:0},cur={x:0,y:0}; let raf;
    const tick=()=>{
      raf=requestAnimationFrame(tick);
      const t=clk.getElapsedTime();
      grp.rotation.y=t*.17; grp.rotation.x=Math.sin(t*.11)*.11; grp.position.y=Math.sin(t*.42)*.20;
      tetra.rotation.y=-t*.38; tetra.rotation.x=t*.24;
      tgt.x=mouse.current.y*.55; tgt.y=mouse.current.x*.55;
      cur.x+=(tgt.x-cur.x)*.038; cur.y+=(tgt.y-cur.y)*.038;
      grp.rotation.x+=cur.x*.007; grp.rotation.y+=cur.y*.007;
      pts.rotation.y=t*.022; pts.rotation.x=t*.013;
      rings[0].rotation.z=t*.09; rings[1].rotation.z=-t*.062; rings[2].rotation.z=t*.038;
      wire.material.opacity=.05+Math.sin(t*.65)*.07;
      pl1.intensity=10+Math.sin(t*.88)*3.5; pl2.intensity=7+Math.sin(t*1.1)*2.5;
      renderer.render(scene,camera);
    };
    tick();
    return ()=>{ cancelAnimationFrame(raf); window.removeEventListener("mousemove",onMouse); window.removeEventListener("resize",onResize); renderer.dispose(); };
  }, []);

  return (
    <section id="home" style={{ position:"relative",minHeight:"100vh",display:"flex",alignItems:"center",overflow:"hidden" }}>
      <canvas ref={cvs} style={{ position:"absolute",inset:0,display:"block",zIndex:1 }} />
      <div style={{ position:"absolute",inset:0,zIndex:2,background:"radial-gradient(ellipse 90% 75% at 58% 48%,rgba(108,59,255,.11),transparent 65%)" }} />
      <div style={{ position:"absolute",inset:0,zIndex:2,backgroundImage:"linear-gradient(rgba(108,59,255,.035) 1px,transparent 1px),linear-gradient(90deg,rgba(108,59,255,.035) 1px,transparent 1px)",backgroundSize:"62px 62px" }} />
      <div style={{ position:"absolute",bottom:0,left:0,right:0,height:"38%",zIndex:3,background:"linear-gradient(to top,#0B0B0B,transparent)" }} />

      <div className="hero-pad" style={{ position:"relative",zIndex:10,maxWidth:1200,margin:"0 auto",padding:"0 40px",width:"100%",paddingTop:88 }}>
        <div style={{ maxWidth:730 }}>
          <div className="s-tag" style={{ marginBottom:28 }}>
            <span style={{ width:6,height:6,borderRadius:"50%",background:"#6C3BFF",display:"inline-block" }} />
            Premium Video Editing Studio
          </div>
          <h1 style={{ fontSize:"clamp(44px,6.4vw,88px)",fontWeight:900,lineHeight:1.03,letterSpacing:"-.035em",marginBottom:26 }}>
            {WORDS.map((w,i) => (
              <span key={i} className="w-wrap" style={{ marginRight:".22em" }}>
                <span className="w-inner" ref={el=>{ wRefs.current[i]=el; }} style={{ transitionDelay:`${i*38}ms` }}>
                  {["Create","Impact."].includes(w) ? <span className="g-text">{w}</span> : w}
                </span>
              </span>
            ))}
          </h1>
          <p className="w-inner" ref={el=>{ wRefs.current[WORDS.length]=el; }}
            style={{ fontSize:18,color:"rgba(255,255,255,.56)",marginBottom:44,lineHeight:1.68,maxWidth:490 }}>
            High-converting edits for creators and brands that demand results.
          </p>
          <div className="w-inner" ref={el=>{ wRefs.current[WORDS.length+1]=el; }}
            style={{ display:"flex",gap:14,flexWrap:"wrap" }}>
            <button className="btn-p" onClick={()=>document.getElementById("work")?.scrollIntoView({behavior:"smooth"})}>
              View Work
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </button>
            <button className="btn-o" onClick={()=>document.getElementById("contact")?.scrollIntoView({behavior:"smooth"})}>
              Hire Us
            </button>
          </div>
        </div>
      </div>

      <div style={{ position:"absolute",bottom:34,left:"50%",transform:"translateX(-50%)",zIndex:10,display:"flex",flexDirection:"column",alignItems:"center",gap:9,opacity:.38 }}>
        <span style={{ fontSize:10,letterSpacing:".18em",textTransform:"uppercase",fontWeight:700 }}>Scroll</span>
        <div style={{ width:1,height:54,background:"linear-gradient(to bottom,#6C3BFF,transparent)",animation:"scroll-drop 2.2s ease-in-out infinite" }} />
      </div>
    </section>
  );
}

// ── Portfolio ──────────────────────────────────────────────────────────────
const PROJECTS=[
  {title:"Brand Reel Edit",        type:"Ad Creative",    span:2,aspect:"16/8", grad:"linear-gradient(145deg,#14083a,#2d1a7a)"},
  {title:"Creator Content Pack",   type:"Reels Edit",     span:1,aspect:"4/5",  grad:"linear-gradient(145deg,#08152e,#18306e)"},
  {title:"Social Ad Campaign",     type:"Ad Creative",    span:2,aspect:"16/6", grad:"linear-gradient(145deg,#14083a,#3d1a88)"},
];
const ShapeA=()=>(<svg viewBox="0 0 240 160" style={{position:"absolute",inset:0,width:"100%",height:"100%",opacity:.2}}><circle cx="120" cy="80" r="55" stroke="rgba(108,59,255,.8)" strokeWidth="1" fill="none"/><polygon points="120,20 200,145 40,145" stroke="rgba(139,92,246,.55)" strokeWidth="1" fill="none"/><circle cx="120" cy="80" r="22" fill="rgba(108,59,255,.18)"/><line x1="65" y1="80" x2="175" y2="80" stroke="rgba(108,59,255,.3)" strokeWidth=".7"/></svg>);
const ShapeB=()=>(<svg viewBox="0 0 140 180" style={{position:"absolute",inset:0,width:"100%",height:"100%",opacity:.18}}><rect x="22" y="22" width="96" height="136" rx="18" stroke="rgba(59,130,246,.7)" strokeWidth="1" fill="none"/><rect x="42" y="55" width="56" height="70" rx="10" fill="rgba(59,130,246,.12)" stroke="rgba(59,130,246,.35)" strokeWidth="1"/></svg>);
const ShapeC=()=>(<svg viewBox="0 0 140 180" style={{position:"absolute",inset:0,width:"100%",height:"100%",opacity:.18}}><polygon points="70,12 132,148 8,148" stroke="rgba(16,185,129,.7)" strokeWidth="1" fill="rgba(16,185,129,.06)"/><circle cx="70" cy="112" r="22" stroke="rgba(16,185,129,.5)" strokeWidth="1" fill="rgba(16,185,129,.1)"/></svg>);
const ShapeD=()=>(<svg viewBox="0 0 200 160" style={{position:"absolute",inset:0,width:"100%",height:"100%",opacity:.18}}><circle cx="100" cy="80" r="64" stroke="rgba(245,158,11,.45)" strokeWidth="1" strokeDasharray="10 5" fill="none"/><circle cx="100" cy="80" r="32" fill="rgba(245,158,11,.09)"/><line x1="100" y1="16" x2="100" y2="144" stroke="rgba(245,158,11,.25)" strokeWidth=".8"/><line x1="36" y1="80" x2="164" y2="80" stroke="rgba(245,158,11,.25)" strokeWidth=".8"/></svg>);
const ShapeE=()=>(<svg viewBox="0 0 400 120" style={{position:"absolute",inset:0,width:"100%",height:"100%",opacity:.18}}><path d="M40,60 Q130,10 200,60 Q270,110 360,60" stroke="rgba(108,59,255,.85)" strokeWidth="1.5" fill="none"/><path d="M40,78 Q130,28 200,78 Q270,128 360,78" stroke="rgba(139,92,246,.45)" strokeWidth="1" fill="none"/><circle cx="200" cy="60" r="12" fill="rgba(108,59,255,.25)"/><circle cx="110" cy="22" r="6" fill="rgba(108,59,255,.18)"/><circle cx="290" cy="98" r="6" fill="rgba(139,92,246,.18)"/></svg>);
const SHAPES=[ShapeA,ShapeB,ShapeC,ShapeD,ShapeE];

function Portfolio() {
  const ref=useRef(null); useReveal(ref);
  return (
    <section id="work" ref={ref} style={{ padding:"120px 0" }}>
      <div style={{ maxWidth:1200,margin:"0 auto",padding:"0 40px" }}>
        <div style={{ marginBottom:56 }}>
          <div className="s-tag rv">Our Work</div>
          <h2 className="rv d1" style={{ fontSize:"clamp(34px,5vw,64px)",fontWeight:800,letterSpacing:"-.03em",lineHeight:1.1,marginTop:18,marginBottom:14 }}>
            Projects That <span className="g-text">Perform</span>
          </h2>
          <p className="rv d2" style={{ fontSize:16,color:"rgba(255,255,255,.45)",maxWidth:480,lineHeight:1.72 }}>
            Every frame crafted to stop scrolls, hold attention, and drive conversions.
          </p>
        </div>
        <div className="port-grid">
          {PROJECTS.map((p,i) => {
            const Shape=SHAPES[i];
            return (
              <div key={i} className={`p-card rv d${Math.min(i+1,5)}${p.span===2?" port-span2":""}`}
                style={{ gridColumn:`span ${p.span}`,aspectRatio:p.aspect,background:p.grad,minHeight:i===0?270:190 }}>
                <Shape/>
                <div style={{ position:"absolute",inset:0,background:"radial-gradient(circle at 38% 38%,rgba(108,59,255,.22),transparent 58%)" }} />
                <div className="p-overlay">
                  <div style={{ width:52,height:52,borderRadius:"50%",background:"rgba(255,255,255,.11)",backdropFilter:"blur(12px)",display:"flex",alignItems:"center",justifyContent:"center" }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M8 5v14l11-7z"/></svg>
                  </div>
                  <span style={{ fontSize:11,color:"rgba(255,255,255,.72)",letterSpacing:".07em",textTransform:"uppercase",fontWeight:700 }}>View Project</span>
                </div>
                <div style={{ position:"absolute",bottom:0,left:0,right:0,padding:"20px 22px",background:"linear-gradient(to top,rgba(11,11,11,.95),transparent)" }}>
                  <div style={{ fontSize:11,color:"rgba(255,255,255,.44)",letterSpacing:".08em",textTransform:"uppercase",fontWeight:600,marginBottom:4 }}>{p.type}</div>
                  <div style={{ fontSize:15,fontWeight:700 }}>{p.title}</div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="rv" style={{ textAlign:"center",marginTop:44 }}>
          <button className="btn-o">View Full Portfolio →</button>
        </div>
      </div>
    </section>
  );
}

// ── Services ───────────────────────────────────────────────────────────────
const SVCS=[
  {num:"01",icon:"🎬",title:"Reels Editing",   desc:"Hook in 3 seconds. Retain for 60. Our reels are engineered to dominate algorithms and maximize engagement rates.",tags:["Instagram","TikTok","YouTube Shorts"]},
  {num:"02",icon:"📣",title:"Ad Creatives",    desc:"High-converting video ads with scroll-stopping hooks, crystal-clear CTAs, and proven psychological triggers.",    tags:["Meta Ads","Google Ads","UGC"]},
];
function Services() {
  const ref=useRef(null); useReveal(ref);
  return (
    <section id="services" ref={ref} style={{ padding:"120px 0",background:"linear-gradient(180deg,#0B0B0B,rgba(108,59,255,.03) 50%,#0B0B0B)" }}>
      <div style={{ maxWidth:1200,margin:"0 auto",padding:"0 40px" }}>
        <div style={{ textAlign:"center",marginBottom:72 }}>
          <div className="s-tag rv" style={{ margin:"0 auto 22px" }}>Services</div>
          <h2 className="rv d1" style={{ fontSize:"clamp(34px,5vw,64px)",fontWeight:800,letterSpacing:"-.03em",lineHeight:1.1,marginBottom:14 }}>
            What We <span className="g-text">Create</span>
          </h2>
          <p className="rv d2" style={{ fontSize:16,color:"rgba(255,255,255,.44)",maxWidth:456,margin:"0 auto",lineHeight:1.72 }}>
            Two service pillars, each crafted to elevate your brand's visual presence.
          </p>
        </div>
        <div className="svc-grid">
          {SVCS.map((s,i) => (
            <div key={i} className={`svc-card rv d${i+1}`}>
              <div style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:26 }}>
                <span style={{ fontSize:38 }}>{s.icon}</span>
                <span style={{ fontSize:12,color:"rgba(108,59,255,.55)",fontWeight:700,letterSpacing:".1em" }}>{s.num}</span>
              </div>
              <h3 style={{ fontSize:22,fontWeight:700,letterSpacing:"-.02em",marginBottom:14 }}>{s.title}</h3>
              <p style={{ fontSize:14,color:"rgba(255,255,255,.5)",lineHeight:1.78,marginBottom:24 }}>{s.desc}</p>
              <div style={{ display:"flex",flexWrap:"wrap",gap:7,marginBottom:28 }}>
                {s.tags.map(t=>(
                  <span key={t} style={{ padding:"4px 12px",background:"rgba(108,59,255,.13)",border:"1px solid rgba(108,59,255,.24)",borderRadius:50,fontSize:11,fontWeight:600,color:"#a78bfa",letterSpacing:".05em" }}>{t}</span>
                ))}
              </div>
              <div style={{ fontSize:13,fontWeight:600,color:"#6C3BFF",display:"flex",alignItems:"center",gap:6,cursor:"pointer" }}>
                Learn more
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6C3BFF" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── Why IBVFX ──────────────────────────────────────────────────────────────
const WHY=[
  {icon:"⚡",text:"Same-day turnarounds on rush edits"},
  {icon:"🎯",text:"Data-driven — we study what converts"},
  {icon:"✦", text:"Original styles, never templated work"},
  {icon:"∞", text:"Unlimited revisions until it's perfect"},
];
function WhyIBVFX() {
  const ref=useRef(null); useReveal(ref);
  return (
    <section id="about" ref={ref} style={{ padding:"120px 0" }}>
      <div style={{ maxWidth:1200,margin:"0 auto",padding:"0 40px" }}>
        <div className="why-grid">
          <div>
            <div className="s-tag rvl">Why Us</div>
            <h2 className="rvl d1" style={{ fontSize:"clamp(34px,4.5vw,60px)",fontWeight:900,letterSpacing:"-.035em",lineHeight:1.05,marginTop:18,marginBottom:24 }}>
              Most editors<br/>make videos.<br/><span className="g-text">We make moments.</span>
            </h2>
            <p className="rvl d2" style={{ fontSize:16,color:"rgba(255,255,255,.5)",lineHeight:1.82,marginBottom:36 }}>
              We're obsessed with the first 3 seconds. Every cut, every color grade, every sound effect is a deliberate decision to push the viewer forward — and never let them leave.
            </p>
            <div className="rvl d3">
              <button className="btn-p" onClick={()=>document.getElementById("contact")?.scrollIntoView({behavior:"smooth"})}>
                Start Your Project
              </button>
            </div>
          </div>
          <div style={{ display:"flex",flexDirection:"column",gap:11 }}>
            {WHY.map((p,i)=>(
              <div key={i} className={`w-row rvr d${i+1}`}>
                <span style={{ fontSize:18,width:28,textAlign:"center",flexShrink:0 }}>{p.icon}</span>
                <span style={{ fontSize:15,color:"rgba(255,255,255,.78)",fontWeight:500 }}>{p.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ── Magic Chat ─────────────────────────────────────────────────────────────
const CHAT=[
  {delay:700,   from:"client",text:"Can you make my video go viral?"},
  {delay:2000,  from:"typing"},
  {delay:3500,  from:"ibvfx", text:"We don't chase trends. We create them."},
  {delay:5200,  from:"client",text:"What makes your edits different?"},
  {delay:6400,  from:"typing"},
  {delay:8100,  from:"ibvfx", text:"Every cut is intentional. Every frame earns attention."},
  {delay:9700,  from:"client",text:"How fast can you deliver?"},
  {delay:10900, from:"typing"},
  {delay:12400, from:"ibvfx", text:"Most projects: 24–48h. Rush? Same day. ⚡"},
];
function MagicChat() {
  const ref=useRef(null); const fired=useRef(false);
  const [msgs,setMsgs]=useState([]); const [typing,setTyping]=useState(false);
  useReveal(ref);
  useEffect(()=>{
    const el=ref.current; if(!el) return;
    const io=new IntersectionObserver(([e])=>{
      if(e.isIntersecting&&!fired.current){
        fired.current=true;
        CHAT.forEach(item=>setTimeout(()=>{
          if(item.from==="typing") setTyping(true);
          else { setTyping(false); setMsgs(p=>[...p,item]); }
        },item.delay));
      }
    },{threshold:.35});
    io.observe(el); return ()=>io.disconnect();
  },[]);
  return (
    <section ref={ref} style={{ padding:"120px 0" }}>
      <div style={{ maxWidth:1200,margin:"0 auto",padding:"0 40px" }}>
        <div style={{ textAlign:"center",marginBottom:60 }}>
          <div className="s-tag rv" style={{ margin:"0 auto 20px" }}>Experience</div>
          <h2 className="rv d1" style={{ fontSize:"clamp(34px,5vw,64px)",fontWeight:800,letterSpacing:"-.03em",lineHeight:1.1 }}>
            How We <span className="g-text">Think</span>
          </h2>
        </div>
        <div className="rv d2" style={{ maxWidth:520,margin:"0 auto",background:"rgba(255,255,255,.025)",border:"1px solid rgba(255,255,255,.07)",borderRadius:26,padding:"26px 28px",backdropFilter:"blur(20px)" }}>
          <div style={{ display:"flex",alignItems:"center",gap:12,paddingBottom:18,marginBottom:18,borderBottom:"1px solid rgba(255,255,255,.06)" }}>
            <div style={{ width:40,height:40,borderRadius:"50%",background:"linear-gradient(135deg,#6C3BFF,#a78bfa)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:13,flexShrink:0 }}>IB</div>
            <div>
              <div style={{ fontWeight:700,fontSize:14 }}>IBVFX Studio</div>
              <div style={{ display:"flex",alignItems:"center",gap:5,fontSize:11,color:"rgba(255,255,255,.38)" }}>
                <span style={{ width:6,height:6,background:"#10b981",borderRadius:"50%",display:"inline-block" }} />
                Online — replies instantly
              </div>
            </div>
          </div>
          <div style={{ minHeight:300,display:"flex",flexDirection:"column",gap:10 }}>
            {msgs.map((m,i)=>(
              <div key={i} className="c-msg" style={{ display:"flex",justifyContent:m.from==="client"?"flex-start":"flex-end",gap:9,alignItems:"flex-end" }}>
                {m.from==="client"&&(
                  <div style={{ width:28,height:28,borderRadius:"50%",background:"rgba(255,255,255,.08)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,flexShrink:0 }}>👤</div>
                )}
                <div style={{ padding:"11px 16px",maxWidth:"72%",fontSize:14,lineHeight:1.52,fontWeight:500,
                  ...(m.from==="client"
                    ?{background:"rgba(255,255,255,.07)",borderRadius:"16px 16px 16px 4px",color:"rgba(255,255,255,.82)"}
                    :{background:"linear-gradient(135deg,#6C3BFF,#8B5CF6)",borderRadius:"16px 16px 4px 16px",color:"#fff"})
                }}>{m.text}</div>
              </div>
            ))}
            {typing&&(
              <div style={{ display:"flex",justifyContent:"flex-end" }}>
                <div style={{ background:"linear-gradient(135deg,#6C3BFF,#8B5CF6)",borderRadius:"16px 16px 4px 16px",padding:"13px 17px",display:"flex",gap:4,alignItems:"center" }}>
                  {[0,1,2].map(j=>(
                    <div key={j} style={{ width:5,height:5,borderRadius:"50%",background:"rgba(255,255,255,.75)",animation:`dot-blink 1.4s ease-in-out ${j*.2}s infinite` }} />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

// ── Final CTA ──────────────────────────────────────────────────────────────
function CTA() {
  const ref=useRef(null); useReveal(ref);
  return (
    <section id="contact" ref={ref} style={{ padding:"140px 0",textAlign:"center",position:"relative",overflow:"hidden" }}>
      {/* Ambient orbs */}
      <div style={{ position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:700,height:700,borderRadius:"50%",background:"radial-gradient(circle,rgba(108,59,255,.11) 0%,transparent 68%)",pointerEvents:"none" }} />
      <div style={{ position:"absolute",top:"40%",left:"35%",width:340,height:340,borderRadius:"50%",background:"radial-gradient(circle,rgba(139,92,246,.07),transparent 70%)",pointerEvents:"none" }} />

      <div style={{ position:"relative",zIndex:2,maxWidth:900,margin:"0 auto",padding:"0 40px" }}>
        <div className="s-tag rv" style={{ margin:"0 auto 28px" }}>
          <span style={{ width:6,height:6,borderRadius:"50%",background:"#6C3BFF",display:"inline-block" }} />
          Let's Work Together
        </div>
        <h2 className="rv d1" style={{ fontSize:"clamp(38px,6vw,88px)",fontWeight:900,letterSpacing:"-.04em",lineHeight:1.02,marginBottom:22 }}>
          Let's Create Something<br/><span className="g-text">That Stands Out.</span>
        </h2>
        <p className="rv d2" style={{ fontSize:18,color:"rgba(255,255,255,.48)",lineHeight:1.72,marginBottom:52,maxWidth:520,margin:"0 auto 52px" }}>
          Ready to transform your content into something people can't scroll past? Let's build it together.
        </p>

        <div className="rv d3 cta-btns" style={{ display:"flex",gap:16,justifyContent:"center",flexWrap:"wrap",marginBottom:48 }}>
          <button className="btn-p" style={{ fontSize:16,padding:"17px 42px" }}>
            Start a Project
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </button>
          <a href="https://wa.me/9423131038" target="_blank" rel="noopener noreferrer" style={{ textDecoration:"none" }}>
            <button className="btn-o" style={{ fontSize:16,padding:"17px 42px" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.025.507 3.932 1.395 5.606L0 24l6.596-1.33C8.22 23.513 10.07 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.885 0-3.637-.49-5.155-1.343l-.37-.218-3.816.77.793-3.704-.24-.38C2.523 15.677 2 13.902 2 12 2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
              </svg>
              WhatsApp Us
            </button>
          </a>
        </div>

        {/* Contact form */}
        <div className="rv d4" style={{ maxWidth:520,margin:"0 auto",background:"rgba(255,255,255,.025)",border:"1px solid rgba(255,255,255,.07)",borderRadius:24,padding:"36px 36px 28px" }}>
          <h3 style={{ fontSize:18,fontWeight:700,marginBottom:24,letterSpacing:"-.02em" }}>Quick Inquiry</h3>
          <div style={{ display:"flex",flexDirection:"column",gap:12 }}>
            {[
              {ph:"Your name",type:"text"},
              {ph:"Email address",type:"email"},
              {ph:"What kind of content?",type:"text"},
            ].map((f,i)=>(
              <input key={i} type={f.type} placeholder={f.ph}
                style={{ width:"100%",background:"rgba(255,255,255,.05)",border:"1px solid rgba(255,255,255,.1)",borderRadius:12,padding:"13px 16px",color:"#fff",fontSize:14,outline:"none",fontFamily:"inherit",transition:"border-color .25s" }}
                onFocus={e=>e.target.style.borderColor="rgba(108,59,255,.6)"}
                onBlur={e=>e.target.style.borderColor="rgba(255,255,255,.1)"} />
            ))}
            <textarea placeholder="Tell us about your project…" rows={3}
              style={{ width:"100%",background:"rgba(255,255,255,.05)",border:"1px solid rgba(255,255,255,.1)",borderRadius:12,padding:"13px 16px",color:"#fff",fontSize:14,outline:"none",fontFamily:"inherit",resize:"vertical",transition:"border-color .25s" }}
              onFocus={e=>e.target.style.borderColor="rgba(108,59,255,.6)"}
              onBlur={e=>e.target.style.borderColor="rgba(255,255,255,.1)"} />
            <button className="btn-p" style={{ width:"100%",justifyContent:"center",marginTop:4 }}>
              Send Message
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z"/></svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

// ── Footer ─────────────────────────────────────────────────────────────────
function Footer() {
  return (
    <footer style={{ borderTop:"1px solid rgba(255,255,255,.05)",padding:"44px 0" }}>
      <div style={{ maxWidth:1200,margin:"0 auto",padding:"0 40px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:18 }}>
        <div style={{ fontWeight:800,fontSize:20,letterSpacing:"-.03em" }}>
          IB<span style={{ color:"#6C3BFF" }}>VFX</span>
        </div>
        <div style={{ fontSize:13,color:"rgba(255,255,255,.28)" }}>
          © {new Date().getFullYear()} IBVFX Studio. All rights reserved.
        </div>
        <div style={{ display:"flex",gap:20 }}>
          {["Instagram","TikTok","YouTube"].map(s=>(
            <span key={s} style={{ fontSize:13,color:"rgba(255,255,255,.38)",cursor:"pointer",transition:"color .2s",fontWeight:500 }}
              onMouseEnter={e=>e.target.style.color="#a78bfa"}
              onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.38)"}>{s}</span>
          ))}
        </div>
      </div>
    </footer>
  );
}

// ── Custom Cursor ──────────────────────────────────────────────────────────
function Cursor() {
  const dot  = useRef(null);
  const ring = useRef(null);
  const pos  = useRef({x:0,y:0});
  const cur  = useRef({x:0,y:0});
  useEffect(()=>{
    const mv=e=>{pos.current={x:e.clientX,y:e.clientY}};
    window.addEventListener("mousemove",mv);
    let raf;
    const tick=()=>{
      raf=requestAnimationFrame(tick);
      cur.current.x+=(pos.current.x-cur.current.x)*.14;
      cur.current.y+=(pos.current.y-cur.current.y)*.14;
      if(dot.current)  dot.current.style.transform=`translate(${pos.current.x}px,${pos.current.y}px) translate(-50%,-50%)`;
      if(ring.current) ring.current.style.transform=`translate(${cur.current.x}px,${cur.current.y}px) translate(-50%,-50%)`;
    };
    tick();
    return ()=>{ cancelAnimationFrame(raf); window.removeEventListener("mousemove",mv); };
  },[]);
  const isMobile = window.matchMedia("(pointer:coarse)").matches;
  if(isMobile) return null;
  return (
    <>
      <div ref={dot} style={{ position:"fixed",top:0,left:0,width:6,height:6,borderRadius:"50%",background:"#6C3BFF",pointerEvents:"none",zIndex:99999,mixBlendMode:"difference" }} />
      <div ref={ring} style={{ position:"fixed",top:0,left:0,width:32,height:32,borderRadius:"50%",border:"1px solid rgba(108,59,255,.45)",pointerEvents:"none",zIndex:99998,transition:"width .2s,height .2s" }} />
    </>
  );
}

// ── App ────────────────────────────────────────────────────────────────────
export default function App() {
  useEffect(()=>{
    const style=document.createElement("style");
    style.innerHTML=CSS;
    document.head.appendChild(style);
    return ()=>style.remove();
  },[]);
  return (
    <div style={{ background:"#0B0B0B",minHeight:"100vh",cursor:"default" }}>
      {/* Noise grain overlay */}
      <div style={{ position:"fixed",inset:0,zIndex:9999,pointerEvents:"none",opacity:.025,
        backgroundImage:`url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")` }} />
      <Cursor/>
      <Navbar/>
      <Hero/>
      <Portfolio/>
      <Services/>
      <WhyIBVFX/>
      <MagicChat/>
      <CTA/>
      <Footer/>
    </div>
  );
}